<div class="btns-container d-flex flex-column flex-md-row mt-2">
  <app-share-icons-button
    *ngIf="frcShowShareIcon && shareData"
    [shareData]="shareData"
  ></app-share-icons-button>
  <app-bookmark-button-container
    [recordId]="selectedTabRecordId"
    [tabName]="selectedTabName"
    [fgOrEntity]="fgOrEntity"
  >
  </app-bookmark-button-container>
  <app-entity-options-button
    [entityType]="fgOrEntity.entityType"
    [resourceData]="resourceData"
    [editionsData]="editionsData"
  >
  </app-entity-options-button>
</div>
